<template>
  <div class="table-messages-category-list">
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" toggleButtonSize="small" @keyup.enter="loadCategories(1, null, true)">

      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addMessagesCategoryPopup">{{ $t('add') }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('category_name')" v-model="categorySearchParams.title" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('description')" v-model="categorySearchParams.description" class="w-full"/>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadCategories(1, null, true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="messageCategoryDataContainer" :title="$t('category')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-messages-tab-nav></shared-messages-tab-nav>
      </template>

      <shared-messages-category-list
        :categories="categories"
        @customClickEdit="edit"
        @customClickDelete="destroy"
        @customClickSave="save"
        @customClickCancel="cancel"
      ></shared-messages-category-list>

      <template slot="footer">
        <paginate
          :total="categoryPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadCategories"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>
    </vx-card>

    <modal :title="$t('add_category')" :active.sync="modals.add" size="lg">

      <shared-messages-category-add
        @addMessageCategorySuccess="addMessageCategorySuccess"
      ></shared-messages-category-add>

      <vs-divider></vs-divider>

      <div class="flex justify-end">
        <vs-button id="addMessageCategoryButton" color="primary" type="filled" @click.prevent="addCategory">{{ $t('save') }}</vs-button>
      </div>
    </modal>
  </div>
</template>

<script>
import SharedMessagesTabNav from '@/views/Shared/Messages/TabNav'
import MessageCategory from '@/models/MessageCategory'
import SharedMessagesCategoryList from '@/views/Shared/Messages/Category/List'
import SharedMessagesCategoryAdd from '@/views/Shared/Messages/Category/Add'
import Pagination from '@/mixins/paginate'
import Paginate from '@/components/Paginate'
import Modal from '@/components/Modal'
import Utils from '@/helpers/utils'
import { EventBus } from '@/../eventbus'

export default {
  name: 'User.Messages.Category',
  mixins: [Pagination],
  components: {
    SharedMessagesTabNav,
    SharedMessagesCategoryList,
    SharedMessagesCategoryAdd,
    Paginate,
    Modal
  },
  data () {
    return {
      categories: {},
      categoryPages: 0,
      categoryListEdit: {},
      itemPerPage: null,
      categorySearchParams: {
        title: typeof this.$route.query.title !== 'undefined' ? this.$route.query.title : '',
        description: typeof this.$route.query.description !== 'undefined' ? this.$route.query.description : ''
      },

      modals: {
        add: false
      }
    }
  },
  watch: {
    'modals.add' (val) {
      if (!val) {
        EventBus.$emit('initMessageCategoryFormData')
      }
    }
  },
  mounted () {
    this.loadCategories(this.initialPage, null)
    this.$windowOpenerHelper.listenToPopUpMessage('reload_message_category_table', this.loadCategories)
  },
  methods: {
    async loadCategories (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#messageCategoryDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      this.$router.replace({ query: { ...this.categorySearchParams, page, itemPerPage } })
      const response = await MessageCategory.all({ ...this.categorySearchParams, page, itemPerPage })
      this.categories = response.data.data.categories
      this.categoryPages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#messageCategoryDataContainer > .con-vs-loading')
    },
    async edit (key) {
      try {
        this.categories[key].edit = true
        const editElem = this.categories[key]
        const editObj = {
          title: editElem.title,
          description: editElem.description
        }
        this.categoryListEdit[key] = editObj
      } catch (e) {
        // console.log(e)
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: 'Category not found',
          confirmButton: this.$t('confirm')
        })
      }
    },
    async cancel (key) {
      try {
        this.categories[key].title = this.categoryListEdit[key].title
        this.categories[key].description = this.categoryListEdit[key].description
        this.categories[key].edit = false
        delete this.categoryListEdit[key]
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: 'Category not found',
          confirmButton: this.$t('confirm')
        })
      }
    },
    async save (key, id) {
      this.$vs.loading({background: 'primary', color: '#fff', container: `#updateCategoryButton${  id}`, scale: 0.45})
      try {
        await MessageCategory.update(this.categories[key])
        this.categories[key].edit = false
        this.categories[key].categoryFormErrors = {}
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.categories[key].categoryFormErrors = errors.validationErrors
      }
      this.$vs.loading.close(`#updateCategoryButton${  id  } > .con-vs-loading`)
    },
    addCategory () {
      EventBus.$emit('initAddMessageCategory')
    },
    addMessageCategoryModal () {
      this.modals.add = true
    },
    addMessagesCategoryPopup () {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'add-messages-category', {}, this.addMessageCategoryModal)
    },
    async destroy (key, id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$i18n.t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })
      if (confirm.value) {
        await MessageCategory.destroy({ id })
        this.loadCategories(1, this.itemPerPage)
      }
    },
    addMessageCategorySuccess () {
      this.loadCategories()
      this.modals.add = false
    }
  }
}
</script>

<style lang="scss">

</style>
